// services/childcare/reports.js
import { api } from "./utils";

// ==================== REPORTS ====================

// Get report statistics
export const getReportStats = async (startDate, endDate) => {
  try {
    const response = await api.get("/childcare/reports/stats", {
      params: { startDate, endDate },
    });
    return response;
  } catch (error) {
    console.error("Error fetching report stats:", error);
    throw error;
  }
};

// Get payment report
export const getPaymentReport = async (startDate, endDate, filters = {}) => {
  try {
    const response = await api.post("/childcare/reports/generate", {
      report_type: "payment",
      start_date: startDate,
      end_date: endDate,
      ...filters,
    });
    return response;
  } catch (error) {
    console.error("Error fetching payment report:", error);
    throw error;
  }
};

// Get children report
export const getChildrenReport = async (startDate, endDate, filters = {}) => {
  try {
    const response = await api.post("/childcare/reports/generate", {
      report_type: "children",
      start_date: startDate,
      end_date: endDate,
      ...filters,
    });
    return response;
  } catch (error) {
    console.error("Error fetching children report:", error);
    throw error;
  }
};

// Export report
export const exportReport = async (
  reportType,
  startDate,
  endDate,
  format = "csv",
) => {
  try {
    const response = await api.get(`/childcare/reports/export/${reportType}`, {
      params: { start_date: startDate, end_date: endDate, format },
      responseType: "blob",
    });
    return response;
  } catch (error) {
    console.error("Error exporting report:", error);
    throw error;
  }
};

// ==================== SAVED REPORTS ====================

// Get saved reports
export const getSavedReports = async () => {
  try {
    const response = await api.get("/childcare/reports/saved");
    return response;
  } catch (error) {
    console.error("Error fetching saved reports:", error);
    throw error;
  }
};

// Save report configuration
export const saveReport = async (reportData) => {
  try {
    const response = await api.post("/childcare/reports/save", reportData);
    return response;
  } catch (error) {
    console.error("Error saving report:", error);
    throw error;
  }
};

// Update saved report
export const updateSavedReport = async (id, reportData) => {
  try {
    const response = await api.put(
      `/childcare/reports/saved/${id}`,
      reportData,
    );
    return response;
  } catch (error) {
    console.error("Error updating saved report:", error);
    throw error;
  }
};

// Delete saved report
export const deleteSavedReport = async (id) => {
  try {
    const response = await api.delete(`/childcare/reports/saved/${id}`);
    return response;
  } catch (error) {
    console.error("Error deleting saved report:", error);
    throw error;
  }
};

// Schedule report
export const scheduleReport = async (reportId, schedule) => {
  try {
    const response = await api.post("/childcare/reports/schedule", {
      report_id: reportId,
      schedule,
    });
    return response;
  } catch (error) {
    console.error("Error scheduling report:", error);
    throw error;
  }
};

// Cancel scheduled report
export const cancelScheduledReport = async (id) => {
  try {
    const response = await api.delete(`/childcare/reports/scheduled/${id}`);
    return response;
  } catch (error) {
    console.error("Error cancelling scheduled report:", error);
    throw error;
  }
};

// ==================== PROGRESS REPORTS ====================

// Get all progress reports
export const getProgressReports = async (filters = {}) => {
  try {
    const response = await api.get("/childcare/progress-reports", {
      params: filters,
    });
    return response;
  } catch (error) {
    console.error("Error fetching progress reports:", error);
    throw error;
  }
};

// Get reports by child
export const getReportsByChild = async (childId) => {
  try {
    const response = await api.get(
      `/childcare/progress-reports/child/${childId}`,
    );
    return response;
  } catch (error) {
    console.error("Error fetching child reports:", error);
    throw error;
  }
};

// Create progress report
export const createProgressReport = async (reportData) => {
  try {
    const response = await api.post("/childcare/progress-reports", reportData);
    return response;
  } catch (error) {
    console.error("Error creating progress report:", error);
    throw error;
  }
};

// Update progress report
export const updateProgressReport = async (id, reportData) => {
  try {
    const response = await api.put(
      `/childcare/progress-reports/${id}`,
      reportData,
    );
    return response;
  } catch (error) {
    console.error("Error updating progress report:", error);
    throw error;
  }
};

// Delete progress report
export const deleteProgressReport = async (id) => {
  try {
    const response = await api.delete(`/childcare/progress-reports/${id}`);
    return response;
  } catch (error) {
    console.error("Error deleting progress report:", error);
    throw error;
  }
};

// Share report with parent
export const shareReportWithParent = async (id) => {
  try {
    const response = await api.post(`/childcare/progress-reports/${id}/share`);
    return response;
  } catch (error) {
    console.error("Error sharing report:", error);
    throw error;
  }
};

// Publish report
export const publishReport = async (id) => {
  try {
    const response = await api.post(
      `/childcare/progress-reports/${id}/publish`,
    );
    return response;
  } catch (error) {
    console.error("Error publishing report:", error);
    throw error;
  }
};
